import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import { primaryNav } from '@/mocks/gossip';

export default function NotFound() {
  return (
    <>
      <Seo
        title="页面不存在 - 诱惑吃瓜"
        description="你访问的页面不存在或已调整，可以返回首页继续浏览颜值美照、生图红毯与高光同框内容。"
        robots="noindex, follow"
      />
      <div className="mx-auto flex max-w-[1240px] flex-col items-center px-4 py-24 text-center md:px-8 md:py-32">
        <span className="font-heading text-7xl font-black leading-none text-primary-500 md:text-9xl">404</span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面还没有内容
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
          链接可能已经调整，或者输入有误。不妨从下面的栏目重新开始浏览。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {primaryNav.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              {item.label}
            </Link>
          ))}
        </div>
        <Link
          to="/"
          className="mt-8 flex h-11 items-center gap-2 rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-lg" aria-hidden="true"></i>
          返回首页
        </Link>
      </div>
    </>
  );
}